module.exports = __webpack_public_path__ + "media/images/bird-ef7e8073.svg";